/**
 * localStorage for per-device conveniences (the conversation, the theme). It can be
 * unavailable (private mode, blocked storage): then nothing is kept and that is fine.
 */
export function load<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function save(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage full or blocked: not worth bothering the user
  }
}
